import React from 'react';
import { auth } from './firebase'; 

const CaseSyncHub = ({ onNavigate, userName, userRole }) => {
  
  const handleSignOut = () => {
    auth.signOut().catch(error => console.error("Error signing out: ", error));
  };

  // --- ROLE-BASED ACCESS CONTROL (RBAC) LOGIC ---
  const isIA = userRole === 'Instructional Assistant';
  const isECE = userRole === 'ECE Recorder';

  // Define which tiles are restricted for which roles
  const restrictCompliance = isIA;
  const restrictVocational = isECE;
  const restrictProgress = isECE;
  const restrictCaseload = isIA || isECE; // <-- NOW LOCKED FOR IA AND ECE

  return (
    <div style={{ backgroundColor: '#f4f7f6', minHeight: '100vh', padding: '40px 20px', fontFamily: 'sans-serif' }}>
      
      {/* Top Navigation Bar */}
      <div style={{ maxWidth: '1000px', margin: '0 auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '2px solid #ccc', paddingBottom: '30px', marginBottom: '50px' }}>
        
        <div style={{ display: 'flex', alignItems: 'center', gap: '25px' }}>
          <img src="/casesync-logo.png" alt="CaseSync Logo" style={{ height: '90px', objectFit: 'contain' }} />
          <div>
            <h1 style={{ margin: 0, color: '#003366', fontSize: '38px', letterSpacing: '-1px', fontWeight: '900' }}>CaseSync OS</h1>
            <p style={{ margin: '5px 0 0 0', color: '#666', fontSize: '18px' }}>Welcome back, {userName || 'Educator'}.</p>
          </div>
        </div>

        <div style={{ display: 'flex', gap: '15px', alignItems: 'center' }}>
          
          {userRole === 'SuperAdmin' && (
            <button 
              onClick={() => onNavigate('settings')}
              style={{ padding: '10px 20px', backgroundColor: '#e6f0fa', color: '#003366', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: 'bold', fontSize: '14px', transition: 'background-color 0.2s' }}
              onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#cce0ff'}
              onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#e6f0fa'}
            >
              ⚙️ District Settings
            </button>
          )}

          <button 
            onClick={handleSignOut}
            style={{ padding: '10px 20px', backgroundColor: '#fff', color: '#ba0c2f', border: '2px solid #ba0c2f', borderRadius: '6px', cursor: 'pointer', fontWeight: 'bold', fontSize: '14px', transition: 'all 0.2s' }}
            onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#ba0c2f'; e.currentTarget.style.color = '#fff'; }}
            onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#fff'; e.currentTarget.style.color = '#ba0c2f'; }}
          >
            Sign Out
          </button>
        </div>
      </div>

      {/* The Waffle Grid */}
      <div style={{ maxWidth: '1000px', margin: '0 auto', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '20px' }}>
        
        {/* --- COMPLIANCE ENGINE --- */}
        <div 
          onClick={() => !restrictCompliance ? onNavigate('compliance') : null}
          style={{ 
            backgroundColor: restrictCompliance ? '#f9f9f9' : '#fff', 
            padding: '30px 20px', 
            borderRadius: '8px', 
            boxShadow: restrictCompliance ? 'none' : '0 4px 6px rgba(0,0,0,0.05)', 
            borderTop: restrictCompliance ? '6px solid #ccc' : '6px solid #ba0c2f', 
            cursor: restrictCompliance ? 'not-allowed' : 'pointer',
            transition: 'transform 0.2s ease, box-shadow 0.2s ease',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
            opacity: restrictCompliance ? 0.6 : 1
          }}
          onMouseEnter={(e) => { if(!restrictCompliance) { e.currentTarget.style.transform = 'translateY(-5px)'; e.currentTarget.style.boxShadow = '0 8px 12px rgba(0,0,0,0.1)'; } }}
          onMouseLeave={(e) => { if(!restrictCompliance) { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 4px 6px rgba(0,0,0,0.05)'; } }}
        >
          <div style={{ fontSize: '40px', marginBottom: '15px', filter: restrictCompliance ? 'grayscale(100%)' : 'none' }}>⏱️</div>
          <h3 style={{ margin: '0 0 10px 0', color: restrictCompliance ? '#999' : '#333' }}>Compliance Engine</h3>
          <p style={{ margin: 0, color: restrictCompliance ? '#999' : '#666', fontSize: '13px' }}>Manage IEP deadlines, 60-day tracking, and automated alerts.</p>
          {restrictCompliance ? (
            <span style={{ marginTop: '15px', padding: '4px 8px', backgroundColor: '#eee', color: '#666', fontSize: '11px', fontWeight: 'bold', borderRadius: '12px' }}>Restricted</span>
          ) : (
            <span style={{ marginTop: '15px', padding: '4px 8px', backgroundColor: '#e6f0fa', color: '#003366', fontSize: '11px', fontWeight: 'bold', borderRadius: '12px' }}>Live</span>
          )}
        </div>

        {/* --- VOCATIONAL TRACKER --- */}
        <div 
          onClick={() => !restrictVocational ? onNavigate('vocational') : null}
          style={{ 
            backgroundColor: restrictVocational ? '#f9f9f9' : '#fff', 
            padding: '30px 20px', 
            borderRadius: '8px', 
            boxShadow: restrictVocational ? 'none' : '0 4px 6px rgba(0,0,0,0.05)', 
            borderTop: restrictVocational ? '6px solid #ccc' : '6px solid #003366', 
            cursor: restrictVocational ? 'not-allowed' : 'pointer',
            transition: 'transform 0.2s ease, box-shadow 0.2s ease',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
            opacity: restrictVocational ? 0.6 : 1
          }}
          onMouseEnter={(e) => { if(!restrictVocational) { e.currentTarget.style.transform = 'translateY(-5px)'; e.currentTarget.style.boxShadow = '0 8px 12px rgba(0,0,0,0.1)'; } }}
          onMouseLeave={(e) => { if(!restrictVocational) { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 4px 6px rgba(0,0,0,0.05)'; } }}
        >
          <div style={{ fontSize: '40px', marginBottom: '15px', filter: restrictVocational ? 'grayscale(100%)' : 'none' }}>🏢</div>
          <h3 style={{ margin: '0 0 10px 0', color: restrictVocational ? '#999' : '#333' }}>Vocational Tracker</h3>
          <p style={{ margin: 0, color: restrictVocational ? '#999' : '#666', fontSize: '13px' }}>Monitor off-site work-study hours and transition skills.</p>
          {restrictVocational ? (
            <span style={{ marginTop: '15px', padding: '4px 8px', backgroundColor: '#eee', color: '#666', fontSize: '11px', fontWeight: 'bold', borderRadius: '12px' }}>Restricted</span>
          ) : (
            <span style={{ marginTop: '15px', padding: '4px 8px', backgroundColor: '#e6f0fa', color: '#003366', fontSize: '11px', fontWeight: 'bold', borderRadius: '12px' }}>Live</span>
          )}
        </div>

        {/* --- PROGRESS MONITOR --- */}
        <div 
          onClick={() => !restrictProgress ? onNavigate('progress') : null}
          style={{ 
            backgroundColor: restrictProgress ? '#f9f9f9' : '#fff', 
            padding: '30px 20px', 
            borderRadius: '8px', 
            boxShadow: restrictProgress ? 'none' : '0 4px 6px rgba(0,0,0,0.05)', 
            borderTop: restrictProgress ? '6px solid #ccc' : '6px solid #6f42c1', 
            cursor: restrictProgress ? 'not-allowed' : 'pointer',
            transition: 'transform 0.2s ease, box-shadow 0.2s ease',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
            opacity: restrictProgress ? 0.6 : 1
          }}
          onMouseEnter={(e) => { if(!restrictProgress) { e.currentTarget.style.transform = 'translateY(-5px)'; e.currentTarget.style.boxShadow = '0 8px 12px rgba(0,0,0,0.1)'; } }}
          onMouseLeave={(e) => { if(!restrictProgress) { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 4px 6px rgba(0,0,0,0.05)'; } }}
        >
          <div style={{ fontSize: '40px', marginBottom: '15px', filter: restrictProgress ? 'grayscale(100%)' : 'none' }}>📊</div>
          <h3 style={{ margin: '0 0 10px 0', color: restrictProgress ? '#999' : '#333' }}>Progress Monitor</h3>
          <p style={{ margin: 0, color: restrictProgress ? '#999' : '#666', fontSize: '13px' }}>Digital data collection for daily IEP goal tracking.</p>
          {restrictProgress ? (
            <span style={{ marginTop: '15px', padding: '4px 8px', backgroundColor: '#eee', color: '#666', fontSize: '11px', fontWeight: 'bold', borderRadius: '12px' }}>Restricted</span>
          ) : (
            <span style={{ marginTop: '15px', padding: '4px 8px', backgroundColor: '#f3e6ff', color: '#6f42c1', fontSize: '11px', fontWeight: 'bold', borderRadius: '12px' }}>Live</span>
          )}
        </div>

        {/* --- ARC MEETING HUB (Open to all currently) --- */}
        <div 
          onClick={() => onNavigate('archub')}
          style={{ 
            backgroundColor: '#fff', 
            padding: '30px 20px', 
            borderRadius: '8px', 
            boxShadow: '0 4px 6px rgba(0,0,0,0.05)', 
            borderTop: '6px solid #28a745', 
            cursor: 'pointer',
            transition: 'transform 0.2s ease, box-shadow 0.2s ease',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center'
          }}
          onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-5px)'; e.currentTarget.style.boxShadow = '0 8px 12px rgba(0,0,0,0.1)'; }}
          onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 4px 6px rgba(0,0,0,0.05)'; }}
        >
          <div style={{ fontSize: '40px', marginBottom: '15px' }}>📈</div>
          <h3 style={{ margin: '0 0 10px 0', color: '#333' }}>ARC Meeting Hub</h3>
          <p style={{ margin: 0, color: '#666', fontSize: '13px' }}>Automated progress visualizations and printable data.</p>
          <span style={{ marginTop: '15px', padding: '4px 8px', backgroundColor: '#e6ffe6', color: '#28a745', fontSize: '11px', fontWeight: 'bold', borderRadius: '12px' }}>Live</span>
        </div>

        {/* --- CASELOAD MANAGER --- */}
        <div 
          onClick={() => !restrictCaseload ? onNavigate('caseload') : null}
          style={{ 
            backgroundColor: restrictCaseload ? '#f9f9f9' : '#fff', 
            padding: '30px 20px', 
            borderRadius: '8px', 
            boxShadow: restrictCaseload ? 'none' : '0 4px 6px rgba(0,0,0,0.05)', 
            borderTop: restrictCaseload ? '6px solid #ccc' : '6px solid #17a2b8', 
            cursor: restrictCaseload ? 'not-allowed' : 'pointer',
            transition: 'transform 0.2s ease, box-shadow 0.2s ease',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
            opacity: restrictCaseload ? 0.6 : 1
          }}
          onMouseEnter={(e) => { if(!restrictCaseload) { e.currentTarget.style.transform = 'translateY(-5px)'; e.currentTarget.style.boxShadow = '0 8px 12px rgba(0,0,0,0.1)'; } }}
          onMouseLeave={(e) => { if(!restrictCaseload) { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 4px 6px rgba(0,0,0,0.05)'; } }}
        >
          <div style={{ fontSize: '40px', marginBottom: '15px', filter: restrictCaseload ? 'grayscale(100%)' : 'none' }}>🧑‍🏫</div>
          <h3 style={{ margin: '0 0 10px 0', color: restrictCaseload ? '#999' : '#333' }}>Caseload Manager</h3>
          <p style={{ margin: 0, color: restrictCaseload ? '#999' : '#666', fontSize: '13px' }}>Individualize student IEP goals and vocational placements.</p>
          {restrictCaseload ? (
            <span style={{ marginTop: '15px', padding: '4px 8px', backgroundColor: '#eee', color: '#666', fontSize: '11px', fontWeight: 'bold', borderRadius: '12px' }}>Restricted</span>
          ) : (
            <span style={{ marginTop: '15px', padding: '4px 8px', backgroundColor: '#e2f6f9', color: '#17a2b8', fontSize: '11px', fontWeight: 'bold', borderRadius: '12px' }}>Live</span>
          )}
        </div>

        {/* --- TIMESHEET MANAGER --- */}
        <div 
          onClick={() => onNavigate('timesheet')}
          style={{ 
            backgroundColor: '#fff', 
            padding: '30px 20px', 
            borderRadius: '8px', 
            boxShadow: '0 4px 6px rgba(0,0,0,0.05)', 
            borderTop: '6px solid #fd7e14', 
            cursor: 'pointer',
            transition: 'transform 0.2s ease, box-shadow 0.2s ease',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center'
          }}
          onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-5px)'; e.currentTarget.style.boxShadow = '0 8px 12px rgba(0,0,0,0.1)'; }}
          onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 4px 6px rgba(0,0,0,0.05)'; }}
        >
          <div style={{ fontSize: '40px', marginBottom: '15px' }}>🕒</div>
          <h3 style={{ margin: '0 0 10px 0', color: '#333' }}>Timesheet & Leave</h3>
          <p style={{ margin: 0, color: '#666', fontSize: '13px' }}>Classified staff contract tracking and sick/personal day logging.</p>
          <span style={{ marginTop: '15px', padding: '4px 8px', backgroundColor: '#fff0e6', color: '#fd7e14', fontSize: '11px', fontWeight: 'bold', borderRadius: '12px' }}>Live</span>
        </div>

        {/* --- SECURITY SETTINGS --- */}
        <div 
          onClick={() => onNavigate('profile')}
          style={{ 
            backgroundColor: '#fff', 
            padding: '30px 20px', 
            borderRadius: '8px', 
            boxShadow: '0 4px 6px rgba(0,0,0,0.05)', 
            borderTop: '6px solid #343a40', 
            cursor: 'pointer',
            transition: 'transform 0.2s ease, box-shadow 0.2s ease',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center'
          }}
          onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-5px)'; e.currentTarget.style.boxShadow = '0 8px 12px rgba(0,0,0,0.1)'; }}
          onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 4px 6px rgba(0,0,0,0.05)'; }}
        >
          <div style={{ fontSize: '40px', marginBottom: '15px' }}>🔒</div>
          <h3 style={{ margin: '0 0 10px 0', color: '#333' }}>Security Settings</h3>
          <p style={{ margin: 0, color: '#666', fontSize: '13px' }}>Update your password and profile credentials.</p>
          <span style={{ marginTop: '15px', padding: '4px 8px', backgroundColor: '#e9ecef', color: '#343a40', fontSize: '11px', fontWeight: 'bold', borderRadius: '12px' }}>Live</span>
        </div>

        {/* --- COMING SOON: LESSON PACING --- */}
        <div 
          style={{ 
            backgroundColor: '#f9f9f9', 
            padding: '30px 20px', 
            borderRadius: '8px', 
            border: '1px dashed #ccc',
            cursor: 'not-allowed',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
            opacity: 0.7
          }}
        >
          <div style={{ fontSize: '40px', marginBottom: '15px', filter: 'grayscale(100%)' }}>📅</div>
          <h3 style={{ margin: '0 0 10px 0', color: '#999' }}>Lesson Pacing Hub</h3>
          <p style={{ margin: 0, color: '#999', fontSize: '13px' }}>Automated 41-week instructional mapping and unit planning.</p>
          <span style={{ marginTop: '15px', padding: '4px 8px', backgroundColor: '#eee', color: '#666', fontSize: '11px', fontWeight: 'bold', borderRadius: '12px' }}>In Development</span>
        </div>

      </div>
    </div>
  );
};

export default CaseSyncHub;